import {
  ConvertResDocument,
  ConvertResMutationResult,
  ConvertResMutationVariables,
} from "@graphql/api";

export default async function convertRes(resId: number): Promise<boolean> {
  const client = global.window.apolloClient;
  const mutVars: ConvertResMutationVariables = { resId };
  const result: ConvertResMutationResult = await client.mutate({
    mutation: ConvertResDocument,
    variables: mutVars,
  });

  const response = result.data?.convertRes;
  
  // Log error details if available (for debugging)
  if (!response?.success && response?.errorType) {
    console.error(`ConvertRes failed: ${response.errorType} - ${response.message}`);
  }

  return response?.success || false;
}
